import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModulesComponent } from '../../service/modules/modules.component';
import { ServerService } from '../../service/server/server.service';
import { MessageService } from '../../service/message/message.service';
import { WharehouseOrderMaterialAddComponent } from '../../wharehouse/wharehouse-order-material-add/wharehouse-order-material-add.component';
import { InvoiceOrderBuyMaterialListComponent } from '../invoice-order-buy-material-list/invoice-order-buy-material-list.component';

@Component({
  selector: 'app-invoice-order-buy-material-detaile',
  templateUrl: './invoice-order-buy-material-detaile.component.html',
  styleUrls: ['./invoice-order-buy-material-detaile.component.scss']
})
export class InvoiceOrderBuyMaterialDetaileComponent implements OnInit, OnDestroy {
  public user_info: any = JSON.parse(<any>localStorage.getItem('user_info'));
  public loading: boolean = false;
  public group: number = 0;
  public temp_number: number = 0;
  public material_id: number = 0;
  public type_task!: number;
  public subscription: Subscription | any;
  public form1_group: FormGroup | any;
  public server!: any;
  public user_id!: number;
  public id!: number;
  public code!: number;
  public ref!: string;
  public ref2!: string;
  public invoice_id!: number;
  public token!: number;
  public trash!: number;
  public creator!: number;
  public level!: number;
  public result!: any;
  public last_financial2_id!: number;
  public last_order_id!: number;
  public searial_selected: any = [];
  public searial_selected_index!: number;
  constructor(
    public serverService: ServerService,
    public router: Router,
    public messageService: MessageService,
    public matSnackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any,
    public dialog: MatDialog,
    public matDialogRef: MatDialogRef<InvoiceOrderBuyMaterialDetaileComponent>) {
    this.server = this.serverService.get_server();

    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
    if (dialog_data) {
      this.ref = dialog_data.ref;
      this.ref2 = dialog_data.ref2;
      this.trash = dialog_data.trash;
      this.invoice_id = dialog_data.invoice_id;
      this.type_task = dialog_data.type_task;
      this.last_financial2_id = dialog_data.last_financial2_id;
      this.last_order_id = dialog_data.last_order_id;
      this.create_form1();
      this.id = dialog_data.id;
      this.token = dialog_data.token;
      this.code = dialog_data.code;
      if (this.type_task == 1) {
        this.check_access(5);
      }
      if (this.type_task == 2) {
        this.check_access(4);
      }
    }
  }//end consructor
  ngOnInit() {
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
  }
  create_form1() {
    this.form1_group = new FormGroup({
      'comment': new FormControl(null),
      'cost': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'discount': new FormControl(0, [Validators.pattern('[0-9]{1,}')]),
      'number': new FormControl(null, [Validators.pattern('[0-9.]{1,}')]),
      'material_title': new FormControl(null),
      'material': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'group_title': new FormControl(null),
    });
    if (this.type_task == 2) {
      this.form1_group.controls['material_title'].disable();
      this.form1_group.controls['material'].disable();
    }
    this.form1_group.controls['group_title'].disable();
  }
  check_access(type_task: any): any {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return false;
    }//end if
    else { this.matSnackBar.dismiss(); }

    if (!this.form1_group.valid && (type_task == 1 || type_task == 2)) {
      return false;
    }
    this.loading = true;
    var obj = {
      'address': 6,
      'type': 'user',
      'user_id': this.user_id,
      'id': this.code
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['result'][0].count == 0) {
            this.message(true, this.messageService.access2(), 1, this.messageService.close());
          }
          else {
            this.loading = false;
            this.creator = res['creator'];
            this.level = res['level'];
            if (type_task == 1 || type_task == 2) {
              if (type_task == 1) {
                this.insert();
              }
              if (type_task == 2) {
                this.check_for_update1();
              }
            }
            if (type_task == 4) {
              this.get_data();
            }
          }
        }//end if
        else {
          this.message(true, this.messageService.access(), 1, this.messageService.close());
        }
      }
    )
  }
  get_data(): any {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return false;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      'address': 7265,
      'id': this.id,
      'creator': this.creator,
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['num'] == 1) {
            this.form1_group.patchValue({
              'cost': res['result_order_buy'][0].wharehouse_order_cost,
              'discount': res['result_order_buy'][0].wharehouse_order_discount,
              'comment': res['result_order_buy'][0].wharehouse_order_comment,
              'material_title': res['result_order_buy'][0].wharehouse_material_title,
              'material': res['result_order_buy'][0].wharehouse_material_id,
              'number': res['result_order_buy'][0].wharehouse_order_number,
              'group_title': res['result_order_buy'][0].wharehouse_group_title + " | " + res['result_order_buy'][0].wharehouse_material_cate_title,
            });
            if (res['result_order_buy'][0].wharehouse_material_coding) {
              this.form1_group.patchValue({
                'group_title': res['result_order_buy'][0].wharehouse_group_title + " | " + res['result_order_buy'][0].wharehouse_material_cate_title + " | " + res['result_order_buy'][0].wharehouse_material_coding,
              })
            }
            this.temp_number = res['result_order_buy'][0].wharehouse_order_number;
            this.material_id = res['result_order_buy'][0].wharehouse_material_id;
          }//end if
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  //********************************************************************************************************************* */
  insert() {
    this.loading = true;
    var obj = {
      'address': 7262,
      'creator': this.creator,
      'token': this.token,
      "user_id": this.user_id,
      'service': this.form1_group.value.service,
      'number': this.form1_group.value.number,
      'cost': this.form1_group.value.cost,
      'comment': this.form1_group.value.comment,
      'discount': this.form1_group.value.discount,
      'invoice_id': this.invoice_id,
      'material_id': this.form1_group.value.material,
      'last_financial2_id': this.last_financial2_id,
      'searial_selected': this.searial_selected
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1 && res['num'] == 1) {
          this.result = res['result'][0];
          this.matDialogRef.close({ result: this.result })
          this.message(true, this.messageService.save(), 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_save(), 1, this.messageService.close());
        }
      }
    );
  }//end update
  //*************************************************************************************************************** */
  check_for_update1(): any {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return false;
    }//end if
    else { this.matSnackBar.dismiss(); }

    if (this.form1_group.value.number == this.temp_number || this.form1_group.value.number > this.temp_number) {
      this.update();
    }
    else {
      this.loading = true;
      var obj = {
        'address': 7267,
        'id': this.id,
        'creator': this.creator,
      }
      this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
        (res: any) => {
          if (res['status'] == 1 && res['num'] == 1) {
            if (res['result'][0].wharehouse_order_number_consumed <= Number(this.form1_group.value.number)) {
              this.update();
            }
            else {
              var pe_message = "تعداد خرید نمی تواند کمتر از مقدار مصرف شده باشد";
              this.message(true, this.messageService.message(pe_message), 1, this.messageService.close());
            }
          }//end if
          else {
            this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
          }
        }
      )
    }
  }
  update(): any {
    if (this.form1_group.value.discount > this.form1_group.value.cost * this.form1_group.value.number) {
      var pe_message = "مقدار تخفیف نمی تواند بیشتر از قیمت اصلی باشد";
      this.message(true, this.messageService.message(pe_message), 1, this.messageService.close());
      return false;
    }
    this.loading = true;
    var obj = {
      'address': 7263,
      "user_id": this.user_id,
      'token': this.token,
      'trash': this.trash,
      'comment': this.form1_group.value.comment,
      'cost': this.form1_group.value.cost,
      'number': this.form1_group.value.number,
      'discount': this.form1_group.value.discount,
      'id': this.id,
      'invoice_id': this.invoice_id,
      'material_id': this.material_id,
      'creator': this.creator,
      'last_financial2_id': this.last_financial2_id,
      'last_order_id': this.last_order_id
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.result = res['result'][0];
          this.matDialogRef.close(
            { result: this.result }
          )
          this.message(true, this.messageService.save(), 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_save(), 1, this.messageService.close());
        }
      }
    );
  }//end update
  //******************************************************************************************************** */
  get_materials() {
    const dialogRef = this.dialog.open(InvoiceOrderBuyMaterialListComponent, {
      width: '80rem',
      height: 'auto',
      data: {
        creator: this.creator,
        token: this.token,
        code: this.code,
        searial_selected: this.searial_selected,
        searial_selected_index: this.searial_selected_index,
        ref: 'invoice'
      }
    });
    dialogRef.afterClosed().subscribe(
      (res: any) => {
        if (res) {
          this.get_material(res.material_id);
        }
      }
    )
  }
  get_material(material_id: number) {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return false;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      'address': 7256,
      'material_id': material_id,
      'creator': this.creator
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.form1_group.patchValue({
            'material_title': res['result'][0].wharehouse_material_title,
            'material': res['result'][0].wharehouse_material_id,
            'group_title': res['result'][0].wharehouse_group_title + " | " + res['result'][0].wharehouse_material_cate_title,
          });
          if (res['result'][0].wharehouse_material_coding) {
            this.form1_group.patchValue({
              'group_title': res['result'][0].wharehouse_group_title + " | " + res['result'][0].wharehouse_material_cate_title + " | " + res['result'][0].wharehouse_material_coding,
            })
          }
          this.material_id = res['result'][0].wharehouse_material_id;
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  add_material() {
    const dialogRef = this.dialog.open(WharehouseOrderMaterialAddComponent, {
      width: '30rem',
      height: 'auto',
      data: { creator: this.creator, ref: 'reception' }
    });
    dialogRef.afterClosed().subscribe(
      (res: any) => {
        if (res) {
          this.form1_group.patchValue({
            'material_title': res.wharehouse_material_title,
            'material': res.wharehouse_material_id,
            'group_title': res.wharehouse_group_title + " | " + res.wharehouse_material_cate_title,
            'cost': res.wharehouse_order_cost,
            'number': 1,
          });
          if (res.wharehouse_material_coding) {
            this.form1_group.patchValue({
              'group_title': res.wharehouse_group_title + " | " + res.wharehouse_material_cate_title + " | " + res.wharehouse_material_coding,
            })
          }
        }
      }
    )
  }
  //******************************************************************************************************************* */
  load_services(id: number): any {
    var code_id;
    const dialogRef = this.dialog.open(ModulesComponent, {
      width: '40rem',
      height: 'auto',
      disableClose: true,
      data: { id: id, creator: this.creator, code_id: code_id }
    });

    dialogRef.afterClosed().subscribe(
      (res: any) => {
        if (res) {
          if (id == 171) {
            this.form1_group.patchValue({
              'material': res.id,
              'material_title': res.title
            })
          }
        }
      }
    )
  }
  reset_input(id: number): any {
    if (id == 171) {
      this.form1_group.patchValue({
        'material': null,
        'material_title': null,
        'group_title': null,
        'price': null,
      })
    }
  }
  close() {
    this.matDialogRef.close();
  }
  //**************************************************
  required(): any {
    return true;
  }
  message(validation: boolean, message: string, type: number, action: string) {
    if (type == 1) this.loading = false;
    if (validation == true) {
      this.matSnackBar.open(message, action, { duration: 4000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }//end 
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}


